"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogActions = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Dialog_1 = require("../../designTokens/Dialog");
const StackView_1 = require("../../../StackView");
exports.StyledDialogActions = (0, styled_components_1.default)(StackView_1.StackView) `
    & > *:nth-child(n + 2) {
        margin-left: ${Dialog_1.dialogTokens.dialogFooterControlsIndent.getVar()};
    }
`;
//# sourceMappingURL=DialogActions.styles.js.map